"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDataPermissionsAction = exports.setPermissionsAction = exports.setUserDataLoadingAction = exports.setUserAuthentificateAction = exports.resetUserDataAction = exports.setIsUserCriticalAction = exports.setUserDataAction = void 0;
var databus_1 = require("@portals/databus");
var constants_1 = require("./constants");
var setUserDataAction = function (userData) {
    var _a;
    new databus_1.Databus({ name: constants_1.USER_DATA }).addEvent({
        detail: {
            userData: userData,
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.USER_DATA] = userData,
            _a),
    });
};
exports.setUserDataAction = setUserDataAction;
var setIsUserCriticalAction = function (isCriticalAction) {
    var _a;
    new databus_1.Databus({ name: constants_1.USER_CRITICAL_ACTION }).addEvent({
        detail: {
            isCriticalAction: isCriticalAction,
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.USER_CRITICAL_ACTION] = isCriticalAction,
            _a),
    });
};
exports.setIsUserCriticalAction = setIsUserCriticalAction;
var resetUserDataAction = function () {
    var _a;
    new databus_1.Databus({ name: constants_1.USER_DATA }).addEvent({
        detail: {
            userData: {},
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.USER_DATA] = {},
            _a),
    });
};
exports.resetUserDataAction = resetUserDataAction;
var setUserAuthentificateAction = function (authenticated) {
    var _a;
    new databus_1.Databus({ name: constants_1.AUTHENTIFICATE_USER_STATE }).addEvent({
        detail: {
            authenticated: authenticated,
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.AUTHENTIFICATE_USER_STATE] = authenticated,
            _a),
    });
};
exports.setUserAuthentificateAction = setUserAuthentificateAction;
var setUserDataLoadingAction = function (loading) {
    var _a;
    new databus_1.Databus({ name: constants_1.USER_DATA_LOADING }).addEvent({
        detail: {
            loading: loading,
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.USER_DATA_LOADING] = loading,
            _a),
    });
};
exports.setUserDataLoadingAction = setUserDataLoadingAction;
var setPermissionsAction = function (permissions) {
    var _a;
    new databus_1.Databus({ name: constants_1.USER_PERMISSIONS }).addEvent({
        detail: {
            permissions: permissions,
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.USER_PERMISSIONS] = permissions,
            _a),
    });
};
exports.setPermissionsAction = setPermissionsAction;
var setDataPermissionsAction = function (permissionsData) {
    var _a;
    new databus_1.Databus({ name: constants_1.USER_DATA_PERMISSIONS }).addEvent({
        detail: {
            permissionsData: permissionsData,
        },
    });
    databus_1.Databus.setData({
        values: (_a = {},
            _a[constants_1.USER_DATA_PERMISSIONS] = permissionsData,
            _a),
    });
};
exports.setDataPermissionsAction = setDataPermissionsAction;
